module.exports = "./img/2f22d41d0ea16c4227b4a44705d86610.png";